/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { graphql, Link } from 'gatsby';
import Layout from '../pages/layout';
import { pureTitle, filterGallery, findMainImage } from '../fp';
import PropTypes from 'prop-types';
import usePortfolioImages from '../queries/usePortfolioImages';
import Img from 'gatsby-image';

const Project = ({ data: { markdownRemark }, pageContext }) => {
  const portfolioImages = usePortfolioImages();
  const {
    frontmatter: fm,
    fields: { thumb, id },
    html: __html
  } = markdownRemark;
  const mainImage = portfolioImages.find(findMainImage({ thumb }));
  const gallery = portfolioImages.filter(filterGallery({ id }));
  return (
    <Layout showFooter dynamicTitle={pureTitle(fm.title)}>
      {/* content  */}
      <div className="content">
        <section className="parallax-section">
          <div className="parallax-inner">
            <div
              className="bg"
              data-bg={mainImage.childImageSharp.fixed.src}
              data-top-bottom="transform: translateY(300px);"
              data-bottom-top="transform: translateY(-300px);"
            />
            <div className="overlay" />
          </div>
          <div className="container">
            <div className="page-title">
              <div className="row">
                <div className="col-md-6">
                  <h2>
                    {fm.title.split('|')[0]} <strong> {fm.title.split('|')[1]} </strong>
                  </h2>
                </div>
                <div className="col-md-6">
                  {/* <ul className="creat-list">
                    <li>
                      <Link to="/">2M2 Strona Głowna</Link>
                    </li>
                    <li>
                      <Link to="/portfolio">Portfolio</Link>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* content end */}
      <div className="content">
        <section>
          <div className="container">
            {/*=============== portfolio holder ===============*/}
            <div className="gallery-items three-columns grid-small-pad lightgallery">
              {gallery.map(({ childImageSharp, name }) => (
                <div key={name} className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src={childImageSharp.fixed.src} className="popup-image" data-sub-html={pureTitle(fm.title)}>
                        <span className="overlay" />
                        <Img fluid={childImageSharp.fluid} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
              {/* 2 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src="images/folio/thumbs/1.jpg" className="popup-image" data-sub-html="majority have">
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 2 end*/}
              {/* 3 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src="images/folio/thumbs/1.jpg" className="popup-image" data-sub-html="many variations">
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 3 end*/}
              {/* 4 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a
                        href="https://www.youtube.com/watch?v=oDpSPNIozt8"
                        data-poster="images/folio/thumbs/29.jpg"
                        className="popup-image"
                        data-sub-html="anything embarrassing "
                      >
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 4 end*/}
              {/* 5 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src="images/folio/thumbs/1.jpg" className="popup-image" data-sub-html=" repeat predefined">
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 5 end*/}
              {/* 6 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src="images/folio/thumbs/1.jpg" className="popup-image" data-sub-html="making this">
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 6 end*/}
              {/* 7 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src="images/folio/thumbs/1.jpg" className="popup-image" data-sub-html="All the Lorem Ipsum">
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 7 end*/}
              {/* 8 */}
              {/* <div className="gallery-item">
                  <div className="grid-item-holder">
                    <div className="box-item">
                      <a data-src="images/folio/thumbs/1.jpg" className="popup-image" data-sub-html="repeat predefined chunks as necessary">
                        <span className="overlay" />
                        <img src="images/folio/thumbs/1.jpg" alt="" />
                      </a>
                    </div>
                  </div>
                </div> */}
              {/* 8 end*/}
            </div>
            {/* end gallery items */}
            <div className="custom-inner-holder">
              {/* 1 */}
              <div className="custom-inner">
                <div className="row">
                  <div className="col-md-6">
                    <h3>Opis projektu</h3>
                  </div>
                  <div className="col-md-6">
                    <div className="project-description" dangerouslySetInnerHTML={{ __html }} />
                    {/* <h4>Lorem Ipsum available</h4>
                    <p>
                      There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some
                      form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a
                      passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the
                      Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true
                      generator on the Internet. It uses a dictionary of over 200 Latin words
                    </p>
                    <ul>
                      <li>Door portals plan</li>
                      <li>Furniture specifications</li>
                      <li>Interior design</li>
                    </ul> */}
                    <div className="content-nav">
                      <ul>
                        {pageContext.prev && (
                          <li>
                            <Link className="text-link" to={pageContext.prev}>
                              poprzedni projekt
                            </Link>
                          </li>
                        )}
                        {pageContext.next && (
                          <li>
                            <Link className="text-link" to={pageContext.next}>
                              następny projekt
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* 1 */}
            </div>
            {/* custom-link-holder  end */}
          </div>
        </section>
      </div>
      {/* content end */}
    </Layout>
  );
};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
        thumb
        id
      }
      frontmatter {
        title
        categories
      }
      html
    }
  }
`;

Project.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired
};

export default Project;
